document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cfq').forEach(initCarpetFinderQuiz);
});

function initCarpetFinderQuiz(root) {
  if (root.dataset.cfqInitialized === 'true') return;
  root.dataset.cfqInitialized = 'true';

  const sectionId = root.dataset.sectionId;

  let products = [];
  const dataScript = document.getElementById('CarpetFinderQuizData-' + sectionId);
  if (dataScript) {
    try {
      products = JSON.parse(dataScript.textContent || '[]');
    } catch (err) {
      products = [];
    }
  }

  let weights = {};
  try {
    weights = JSON.parse(root.dataset.weights || '{}');
  } catch (err) {
    weights = {};
  }

  const maxResults = parseInt(root.dataset.maxResults, 10) || 8;
  const whatsappNumber = (root.dataset.whatsapp || '').replace(/[^\d+]/g, '');
  const showroomLink = root.dataset.showroomLink || buildWhatsappLink('a showroom visit');
  const sizeGuideLink = root.dataset.sizeGuideLink || '#';

  const TAG_LABELS = {
    room_living: 'Living Room',
    room_bedroom: 'Bedroom',
    room_dining: 'Dining Room',
    room_hallway: 'Hallway',
    room_entryway: 'Entryway',
    room_office: 'Office',
    room_large_space: 'Large Space',
    size_2x3: '2x3 ft',
    size_3x5: '3x5 ft',
    size_4x6: '4x6 ft',
    size_5x8: '5x8 ft',
    size_6x9: '6x9 ft',
    size_8x10: '8x10 ft',
    size_9x12: '9x12 ft',
    size_10x14: '10x14 ft',
    size_12x16: '12x16 ft',
    size_runner: 'Runner',
    size_oversized: 'Oversized',
    size_custom: 'Custom Size',
    style_minimal: 'Minimal',
    style_modern: 'Modern',
    style_traditional: 'Traditional',
    style_persian: 'Persian',
    style_afghani: 'Afghani',
    style_kilim: 'Kilim',
    style_vintage: 'Vintage',
    style_overdyed: 'Overdyed',
    style_chobi: 'Chobi',
    style_moroccan: 'Moroccan',
    style_tribal: 'Tribal',
    style_statement: 'Statement',
    material_wool: 'Wool',
    material_silk: 'Silk',
    material_wool_silk: 'Wool & Silk',
    material_cotton: 'Cotton',
    material_organic_wool: 'Organic Wool',
    material_handspun_wool: 'Handspun Wool'
  };

  function tagLabel(tag) {
    if (TAG_LABELS[tag]) return TAG_LABELS[tag];
    const parts = tag.split('_');
    parts.shift();
    return parts
      .join(' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  function buildWhatsappLink(context, extra) {
    let message = "Hi! I just used the Carpet Finder quiz on tamircarpets.com";
    if (context) message += ' and would like help with ' + context;
    message += '.';
    if (extra) message += ' ' + extra;
    return 'https://wa.me/' + whatsappNumber.replace('+', '') + '?text=' + encodeURIComponent(message);
  }

  // ---- DOM refs ----
  const startPanel = root.querySelector('[data-panel="start"]');
  const actionPanel = root.querySelector('[data-panel="action"]');
  const resultsPanel = root.querySelector('[data-panel="results"]');
  const questionsWrap = root.querySelector('.cfq__questions');
  const questionEls = Array.from(root.querySelectorAll('.cfq-question'));
  const progressWrap = root.querySelector('.cfq__progress-wrap');
  const progressBar = root.querySelector('.cfq__progress-bar');
  const stepLabel = root.querySelector('.cfq__step-label');
  const startBtn = root.querySelector('.cfq__start-btn');
  const retakeBtn = root.querySelector('.cfq__retake');
  const viewResultsInsteadBtn = root.querySelector('.cfq__view-results-instead');
  const whatsappCta = root.querySelector('.cfq__whatsapp-cta');

  const totalQuestions = questionEls.length;
  const answers = new Array(totalQuestions).fill(null);

  const questions = questionEls.map((el) => ({
    el,
    type: el.dataset.type,
    category: el.dataset.category
  }));

  function normalizeTag(tag) {
    return (tag || '').trim().toLowerCase();
  }

  function allPanels() {
    return [startPanel, questionsWrap, actionPanel, resultsPanel].filter(Boolean);
  }

  function hidePanel(panel) {
    if (panel === questionsWrap) {
      questionEls.forEach((q) => q.setAttribute('hidden', ''));
    } else if (panel) {
      panel.setAttribute('hidden', '');
    }
  }

  function showStart() {
    allPanels().forEach(hidePanel);
    startPanel.removeAttribute('hidden');
    progressWrap.setAttribute('hidden', '');
  }

  function showQuestion(index) {
    allPanels().forEach(hidePanel);
    questionsWrap.removeAttribute('hidden');
    questionEls[index].removeAttribute('hidden');
    progressWrap.removeAttribute('hidden');
    progressBar.style.width = Math.round((index / totalQuestions) * 100) + '%';
    stepLabel.textContent = 'Step ' + (index + 1) + ' of ' + totalQuestions;
    const heading = questionEls[index].querySelector('.cfq-question__title');
    if (heading) heading.setAttribute('tabindex', '-1');
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function showAction(actionType, extraContext) {
    allPanels().forEach(hidePanel);
    actionPanel.removeAttribute('hidden');
    progressWrap.setAttribute('hidden', '');

    const heading = actionPanel.querySelector('.cfq__action-heading');
    const text = actionPanel.querySelector('.cfq__action-text');
    const ctas = actionPanel.querySelector('.cfq__action-ctas');
    const contactWrap = actionPanel.querySelector('.cfq__contact-form-wrap');
    ctas.innerHTML = '';
    contactWrap.setAttribute('hidden', '');

    const roomAnswer = answers.find((a) => a && a.category === 'room');
    const roomContext = roomAnswer && roomAnswer.labels.length ? roomAnswer.labels[0].toLowerCase() : 'your room';

    const configs = {
      room_photo: {
        heading: 'Send Your Room Photo',
        text: "Share a clear, well-lit photo of your room on WhatsApp and Tamir's experts will recommend the perfect carpet for it.",
        ctas: [
          { label: 'Send Room Photo on WhatsApp', href: buildWhatsappLink('a room photo for ' + roomContext), primary: true }
        ]
      },
      size_consult: {
        heading: 'Get Size Guidance',
        text: 'Chat with our team for personalized size advice, or check our size guide for common room dimensions.',
        ctas: [
          { label: 'Chat on WhatsApp', href: buildWhatsappLink('a size consultation for ' + roomContext), primary: true },
          { label: 'View Size Guide', href: sizeGuideLink, primary: false }
        ]
      },
      showroom: {
        heading: 'Book a Showroom Visit',
        text: 'Visit our Lahore showroom to see and feel our carpets in person, or message us to schedule a time.',
        ctas: [
          { label: 'Book on WhatsApp', href: showroomLink, primary: true }
        ]
      },
      contact: {
        heading: "We'll Reach Out to You",
        text: 'Leave your details below and a Tamir carpet specialist will contact you shortly.',
        ctas: [],
        showContactForm: true
      }
    };

    const config = configs[actionType] || configs.room_photo;
    heading.textContent = config.heading;
    text.textContent = config.text;

    config.ctas.forEach((cta) => {
      const a = document.createElement('a');
      a.href = cta.href;
      a.className = 'cfq-button ' + (cta.primary ? 'cfq-button--primary' : 'cfq-button--secondary');
      a.textContent = cta.label;
      if (cta.href.indexOf('wa.me') !== -1) {
        a.target = '_blank';
        a.rel = 'noopener';
      }
      ctas.appendChild(a);
    });

    if (config.showContactForm) {
      contactWrap.removeAttribute('hidden');
      const summaryField = contactWrap.querySelector('.cfq-contact-summary-field');
      if (summaryField) summaryField.value = buildAnswerSummary();
    }
  }

  function buildAnswerSummary() {
    return answers
      .map((a, i) => (a && a.labels.length ? questions[i].category + ': ' + a.labels.join(', ') : null))
      .filter(Boolean)
      .join(' | ');
  }

  function recordAnswer(index, selectedEls) {
    const tags = [];
    const labels = [];
    selectedEls.forEach((el) => {
      labels.push(el.dataset.label || '');
      (el.dataset.tags || '')
        .split(',')
        .map(normalizeTag)
        .filter(Boolean)
        .forEach((t) => tags.push(t));
    });
    answers[index] = { tags, labels, category: questions[index].category };
  }

  function goAfterQuestion(index) {
    const isLast = index === totalQuestions - 1;
    if (!isLast) {
      showQuestion(index + 1);
      return;
    }
    const answer = answers[index];
    const actionTags = answer ? answer.tags.filter((t) => t.indexOf('action:') === 0) : [];
    if (questions[index].type === 'single' && actionTags.length) {
      const action = actionTags[0].split(':')[1];
      if (action === 'results') {
        computeAndShowResults();
      } else {
        showAction(action);
      }
    } else {
      computeAndShowResults();
    }
  }

  // ---- wire up each question ----
  questions.forEach((q, index) => {
    const options = Array.from(q.el.querySelectorAll('.cfq-option'));
    const nextBtn = q.el.querySelector('.cfq-next');
    const backBtn = q.el.querySelector('.cfq-back');
    const skipBtn = q.el.querySelector('.cfq-skip');

    options.forEach((opt) => {
      opt.addEventListener('click', () => {
        if (q.type === 'multiple') {
          opt.classList.toggle('is-selected');
        } else {
          options.forEach((o) => o.classList.remove('is-selected'));
          opt.classList.add('is-selected');
        }
        const anySelected = options.some((o) => o.classList.contains('is-selected'));
        nextBtn.disabled = !anySelected;
      });
    });

    if (backBtn) {
      backBtn.addEventListener('click', () => {
        if (index === 0) {
          showStart();
        } else {
          showQuestion(index - 1);
        }
      });
    }

    if (skipBtn) {
      skipBtn.addEventListener('click', () => {
        recordAnswer(index, []);
        goAfterQuestion(index);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const selected = options.filter((o) => o.classList.contains('is-selected'));
        if (!selected.length) return;
        recordAnswer(index, selected);
        goAfterQuestion(index);
      });
    }
  });

  if (startBtn) {
    startBtn.addEventListener('click', () => {
      showQuestion(0);
    });
  }

  if (viewResultsInsteadBtn) {
    viewResultsInsteadBtn.addEventListener('click', computeAndShowResults);
  }

  if (retakeBtn) {
    retakeBtn.addEventListener('click', () => {
      answers.fill(null);
      questionEls.forEach((el) => {
        el.querySelectorAll('.cfq-option').forEach((o) => o.classList.remove('is-selected'));
        const nextBtn = el.querySelector('.cfq-next');
        if (nextBtn) nextBtn.disabled = true;
      });
      showStart();
    });
  }

  // ---- scoring ----
  function computeAndShowResults() {
    const categoryTags = {};
    let budgetRange = null;

    answers.forEach((answer, i) => {
      if (!answer) return;
      const category = questions[i].category;
      if (category === 'none') return;

      if (category === 'budget') {
        const priceTag = answer.tags.find((t) => t.indexOf('price:') === 0);
        if (priceTag) {
          const range = priceTag.split(':')[1].split('-').map(Number);
          budgetRange = { min: range[0], max: range[1] };
        }
        return;
      }

      if (!categoryTags[category]) categoryTags[category] = new Set();
      answer.tags
        .filter((t) => t.indexOf('action:') !== 0 && t.indexOf('price:') !== 0)
        .forEach((t) => categoryTags[category].add(t));
    });

    const scored = products.map((product) => {
      let score = 0;
      const pTags = (product.tags || []).map(normalizeTag);

      Object.keys(categoryTags).forEach((cat) => {
        const set = categoryTags[cat];
        if (set.size && pTags.some((t) => set.has(t))) {
          score += weights[cat] || 0;
        }
      });

      if (budgetRange && typeof product.raw_price === 'number') {
        if (product.raw_price >= budgetRange.min && product.raw_price <= budgetRange.max) {
          score += weights.budget || 0;
        }
      }

      if (pTags.some((t) => t.indexOf('recommend_') === 0)) {
        score += weights.recommend || 0;
      }

      return { product, score };
    });

    scored.sort((a, b) => b.score - a.score);
    const top = scored.slice(0, maxResults).map((s) => s.product);

    renderResults(top, categoryTags);
  }

  function renderResults(topProducts, categoryTags) {
    allPanels().forEach(hidePanel);
    resultsPanel.removeAttribute('hidden');
    progressWrap.setAttribute('hidden', '');

    const sizeBlock = resultsPanel.querySelector('.cfq__summary-size');
    const styleBlock = resultsPanel.querySelector('.cfq__summary-style');

    const sizeTags = new Set([...(categoryTags.size || []), ...(categoryTags.layout || [])]);
    const sizeLabels = Array.from(sizeTags)
      .filter((t) => t.indexOf('size_') === 0)
      .map(tagLabel);
    if (sizeLabels.length) {
      sizeBlock.querySelector('span').textContent = uniqueList(sizeLabels).slice(0, 3).join(', ');
      sizeBlock.removeAttribute('hidden');
    } else {
      sizeBlock.setAttribute('hidden', '');
    }

    const styleLabels = Array.from(categoryTags.style || [])
      .filter((t) => t.indexOf('style_') === 0)
      .map(tagLabel);
    if (styleLabels.length) {
      styleBlock.querySelector('span').textContent = uniqueList(styleLabels).slice(0, 3).join(', ');
      styleBlock.removeAttribute('hidden');
    } else {
      styleBlock.setAttribute('hidden', '');
    }

    const grid = resultsPanel.querySelector('.cfq__results-grid');
    const noResults = resultsPanel.querySelector('.cfq__no-results');
    grid.innerHTML = '';

    if (!topProducts.length) {
      noResults.removeAttribute('hidden');
    } else {
      noResults.setAttribute('hidden', '');
      topProducts.forEach((product) => grid.appendChild(buildProductCard(product)));
    }

    const roomAnswer = answers.find((a) => a && a.category === 'room');
    const roomContext = roomAnswer && roomAnswer.labels.length ? roomAnswer.labels[0].toLowerCase() : 'your room';
    if (whatsappCta) {
      whatsappCta.href = buildWhatsappLink('a room photo for ' + roomContext);
      whatsappCta.target = '_blank';
      whatsappCta.rel = 'noopener';
    }

    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function uniqueList(arr) {
    return Array.from(new Set(arr));
  }

  function el(tag, className) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  const WISHLIST_KEY = 'tamir-carpet-wishlist';
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (err) {
      return [];
    }
  }
  function toggleWishlist(id) {
    const list = getWishlist();
    const idx = list.indexOf(id);
    if (idx === -1) {
      list.push(id);
    } else {
      list.splice(idx, 1);
    }
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    return idx === -1;
  }

  function buildProductCard(product) {
    const card = el('div', 'cfq-card');

    const imageWrap = el('div', 'cfq-card__image-wrap');
    if (product.image) {
      const img = document.createElement('img');
      img.src = product.image;
      img.alt = product.title || '';
      img.loading = 'lazy';
      imageWrap.appendChild(img);
    }

    const wishlistBtn = el('button', 'cfq-card__wishlist');
    wishlistBtn.type = 'button';
    wishlistBtn.setAttribute('aria-label', 'Save to wishlist');
    wishlistBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 21s-7.5-4.9-10-9.3C.5 8.2 2.3 4.5 6 4.5c2.1 0 3.6 1.2 4.5 2.6.9-1.4 2.4-2.6 4.5-2.6 3.7 0 5.5 3.7 4 7.2C19.5 16.1 12 21 12 21z"/></svg>';
    if (getWishlist().indexOf(product.id) !== -1) wishlistBtn.classList.add('is-active');
    wishlistBtn.addEventListener('click', () => {
      const active = toggleWishlist(product.id);
      wishlistBtn.classList.toggle('is-active', active);
    });
    imageWrap.appendChild(wishlistBtn);
    card.appendChild(imageWrap);

    const body = el('div', 'cfq-card__body');

    const pTags = (product.tags || []).map(normalizeTag);
    const availTag = pTags.find((t) => t.indexOf('availability_') === 0);
    if (availTag) {
      const badge = el('span', 'cfq-card__badge');
      badge.textContent = tagLabel(availTag);
      body.appendChild(badge);
    }

    const title = el('h3', 'cfq-card__title');
    title.textContent = product.title || '';
    body.appendChild(title);

    const metaParts = [];
    const styleTag = pTags.find((t) => t.indexOf('style_') === 0);
    const sizeTag = pTags.find((t) => t.indexOf('size_') === 0);
    const materialTag = pTags.find((t) => t.indexOf('material_') === 0);
    if (styleTag) metaParts.push(tagLabel(styleTag));
    if (sizeTag) metaParts.push(tagLabel(sizeTag));
    if (materialTag) metaParts.push(tagLabel(materialTag));
    if (product.vendor) metaParts.push(product.vendor);
    if (metaParts.length) {
      const meta = el('p', 'cfq-card__meta');
      meta.textContent = metaParts.join(' · ');
      body.appendChild(meta);
    }

    const price = el('p', 'cfq-card__price');
    price.textContent = product.price || '';
    body.appendChild(price);

    const actions = el('div', 'cfq-card__actions');
    const viewLink = document.createElement('a');
    viewLink.href = product.url || '#';
    viewLink.className = 'cfq-card__view';
    viewLink.textContent = 'View Details';
    actions.appendChild(viewLink);

    const waLink = document.createElement('a');
    waLink.href = buildWhatsappLink('this carpet: ' + (product.title || ''));
    waLink.className = 'cfq-card__whatsapp';
    waLink.target = '_blank';
    waLink.rel = 'noopener';
    waLink.textContent = 'Ask on WhatsApp';
    actions.appendChild(waLink);

    body.appendChild(actions);
    card.appendChild(body);

    return card;
  }

  showStart();
}
